module.exports = __webpack_public_path__ + "static/media/lotus_yoga.b59227e1.svg";